export enum SidebarMode {
	Push = 'push',
	Over = 'over',
	Side = 'side'
}
